import React, {ReactElement} from "react";
import {styled} from "@reside/ui";

import {ReportingBreadcrumbLabels} from "../../../../pages/page-reporting/reportingBreadcrumb.helpers";

type Props = Readonly<{
  breadcrumb: ReportingBreadcrumbLabels | null;
  dateSelector: ReactElement;
  exportControl: ReactElement | null;
}>;

export const ReportingActionRow = ({
  breadcrumb,
  dateSelector,
  exportControl,
}: Props) => (
  <Wrapper>
    {breadcrumb ? (
      <Breadcrumb aria-label="Report location">
        <WorkflowLabel>{breadcrumb.workflowLabel}</WorkflowLabel>
        {breadcrumb.submenuLabel ? (
          <>
            <Separator aria-hidden="true">&gt;</Separator>
            <WorkflowLabel>{breadcrumb.submenuLabel}</WorkflowLabel>
          </>
        ) : null}
        <Separator aria-hidden="true">&gt;</Separator>
        <ReportLabel>{breadcrumb.reportLabel}</ReportLabel>
      </Breadcrumb>
    ) : (
      <BreadcrumbPlaceholder aria-hidden="true" />
    )}
    <Actions>
      {dateSelector}
      {exportControl && <Separator aria-hidden="true">|</Separator>}

      {exportControl}
    </Actions>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 15px;
  padding: 20px;
  border: 1px solid ${({theme}) => theme.color.gray10};
  background: ${({theme}) => theme.color.white};
  border-radius: 8px;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
`;

const BreadcrumbPlaceholder = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

const WorkflowLabel = styled.span`
  color: #a8b6ca;
  font-size: 16px;
  line-height: 1.25;
`;

const Separator = styled.span`
  color: #a8b6ca;
  font-size: 16px;
  line-height: 1.25;
`;

const ReportLabel = styled.span`
  color: #203c63;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;
